import type { FC } from 'react';

import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

import { AppImage } from 'components/appImage';
import { CustomWatermark } from 'components/customWatermark';

interface ISliderPreviewProps {
  removedWatermarkImageUrl: string;
  originalImageUrl: string;
}

export const SliderPreview: FC<ISliderPreviewProps> = ({ removedWatermarkImageUrl, originalImageUrl }) => {
  return (
    <div className='w-full h-full bg-black/[0.08] overflow-hidden relative py-1 max-sm:min-h-[240px]'>
      <ReactCompareSlider
        className='h-full w-fit mx-auto'
        itemOne={
          <AppImage
            src={removedWatermarkImageUrl}
            alt='Removed watermark'
            canCopy={false}
            renderImage={(props) => <ReactCompareSliderImage {...props} />}
          />
        }
        itemTwo={
          <>
            <AppImage
              src={originalImageUrl}
              alt='Original'
              canCopy={false}
              renderImage={(props) => <ReactCompareSliderImage {...props} />}
            />
          </>
        }
      />
      <CustomWatermark />
    </div>
  );
};
